(function () {
  // Config

  const SNAP_POINT = 991;
  const navHoverDelay = 250;
  const activeClass = 'is-active';
  let navHoverTimer;

  // Elements

  const bodyEl = document.querySelector('body');
  const navToggleEl = document.querySelector('.js-nav-toggle');
  const navCloseEl = document.querySelector('.js-nav-close');
  const navEl = document.querySelector('.js-nav');
  const navItemEls = document.querySelectorAll('.js-nav-item');
  const navBackEls = document.querySelectorAll('.js-back-btn');
  const navItemLevel1Els = document.querySelectorAll('.nav__item__action--level-1');
  const navItemLevel2Els = document.querySelectorAll('.js-nav-item--mega');

  // Events

  // bail if not there
  if (!navEl) {
    return;
  }
  navToggleEl.addEventListener('click', toggleNav);

  navCloseEl.addEventListener('click', toggleNav);

  navItemEls.forEach((navItem) => {
    navItem.addEventListener('click', handleMobileNavItemClick);
  });

  navBackEls.forEach((back) => {
    back.addEventListener('click', handleBackClick);
  });

  navItemLevel1Els.forEach((navItem) => {
    navItem.addEventListener('mouseenter', handleDesktopNavItemLevel1MouseEnter);
  });

  navItemLevel2Els.forEach((navItem) => {
    navItem.addEventListener('mouseenter', handleDesktopNavItemLevel2MouseEnter);
  });

  navItemLevel2Els.forEach((navItem) => {
    navItem.addEventListener('mouseleave', handleDesktopNavItemLevel2Mouseleave);
  });

  navEl.addEventListener('mouseleave', navMouseLeave);

  bodyEl.addEventListener('click', bodyClick);

  // Toggle navigation (hamburger)- mobile

  function toggleNav() {
    this.classList.toggle('is-active');
    navEl.classList.toggle('is-active');
    bodyEl.classList.toggle('is-unscrollable');
  }

  // Mobile only functions....

  function handleMobileNavItemClick(e) {
    if (window.innerWidth < SNAP_POINT) {
      e.preventDefault();
      const navItemTargetEl = document.querySelector(`[data-nav='${this.dataset.navtarget}']`);
      navItemTargetEl.classList.add('is-active');
    }
  }

  function handleBackClick(e) {
    e.preventDefault();
    this.closest('[data-nav]').classList.remove('is-active');
  }

  // Desktop only functions

  // level 1 mouse enter

  function handleDesktopNavItemLevel1MouseEnter() {
    if (window.innerWidth > SNAP_POINT) {
      const el = this;
      const elCords = el.getBoundingClientRect();
      const activeNavItems = navEl.querySelectorAll('.is-active');
      const navItemTargetEl = document.querySelector(`[data-nav='${el.dataset.navtarget}']`);

      deactivateNav();

      if (navItemTargetEl) {
        const navItemTargetCard: HTMLElement = navItemTargetEl.querySelector('.nav__card');

        // Position target nav  card to be left aligned with toggle element
        navItemTargetCard.style.left = elCords.left - 24 + 'px';

        // Add active class to drop down

        navItemTargetEl.classList.add(activeClass);

        el.classList.add(activeClass);
      }
    }
  }

  // Level 2 mouse enter

  function handleDesktopNavItemLevel2MouseEnter() {
    if (window.innerWidth > SNAP_POINT) {
      const el = this;

      navHoverTimer = setInterval(function () {
        const navItemTargetEl = document.querySelector(`[data-nav='${el.dataset.navtarget}']`);
        const parentCardEl = el.closest('.nav__card--mega');
        const cardActiveEls = parentCardEl?.querySelectorAll('.is-active');

        if (cardActiveEls?.length > 0) {
          cardActiveEls.forEach(function (activeItem, index) {
            activeItem.classList.remove(activeClass);
          });
        }

        if (navItemTargetEl) {
          navItemTargetEl.classList.add(activeClass);
        }
        clearTimeout(navHoverTimer);
      }, navHoverDelay);
    }
  }

  // Level 2 mouse leave

  function handleDesktopNavItemLevel2Mouseleave() {
    if (window.innerWidth > SNAP_POINT) {
      if (navHoverTimer) {
        clearTimeout(navHoverTimer);
      }
    }
  }

  // Mouse leave nav

  function navMouseLeave(e) {
    deactivateNav();
  }

  // Body click

  function bodyClick(e) {
    const navElements = '.nav__drop-down *';
    if (!e.target.matches(navElements)) {
      deactivateNav();
    }
  }

  // Deactivate nav

  function deactivateNav() {
    if (window.innerWidth > SNAP_POINT) {
      const activeNavItems = navEl.querySelectorAll('.is-active');
      if (activeNavItems) {
        activeNavItems.forEach(function (item, index) {
          item.classList.remove(activeClass);
        });
      }
      navEl.classList.remove(activeClass);
    }
  }
})();
